export default __webpack_public_path__ + "static/media/drop-up.9620a328.svg";